(function($) {
    $(window).on("load resize orientationchange", function() {
        // $('.featured-carousel .card-wrapper a').html("Read More");
        setTimeout(function() {
            if ($('js_featured_carousel_events').length === 0) {
                $(".featured-carousel").addClass("arrow-black");
            }
            if ($(".js_featured_carousel_events, .featured-carousel").length > 0) {
                $(".featured-carousel").css("opacity", "1");
                if ($(".featured-carousel .card-wrapper").length > 2) {
                    $(".featured-carousel .row-wrap").not(".slick-initialized").slick({
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: true,
                        autoplay: true,
                        autoplaySpeed: 2000,
                        speed: 2000,
                        infinite: false,
                        responsive: [{
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 1,
                            },
                        }, ],
                    });
                    //$(".featured-carousel.featured-carousel-view .card-wrapper").css("width", "auto");
                    var leftForArrow = $(".featured-carousel .intro-block h4").outerWidth() + 16;

                    $(".featured-carousel .slick-arrow").css("left", leftForArrow);
                    $(".featured-carousel .slick-next").css("left", leftForArrow + 44);
                }
            }
        }, 300);
    });
    $(window).on("load", function() {
        $(".js_featured_research_publishedworkbyfellows .featured-carousel h4").dotdotdot({
            height: 86,
            fallbackToLetter: true,
            watch: true,
        });
        // $(".js_featured_research_publishedworkbyfellows .featured-carousel .card-wrapper p, .featured-carousel .card-wrapper p").dotdotdot({
        //     height: 70,
        //     fallbackToLetter: true,
        //     watch: true,
        // });
        setTimeout(function() {
            $('.featured-carousel .card-img img').removeAttr('loading');
            $('.js_featured_research_publishedworkbyfellows .featured-carousel .card-img img').removeAttr('loading');
            $('.js_featured_carousel_events .featured-carousel .card-img img').removeAttr('loading');
            $('js_featured_carousel_news .featured-carousel .card-img img').removeAttr('loading');
        }, 500);
    });
    $(document).ready(function() {
        // $(".js_featured_research_publishedworkbyfellows .featured-carousel h4, .featured-carousel .card-wrapper h4").dotdotdot({
        //     height: 86,
        //     fallbackToLetter: true,
        //     watch: true,
        // });
        // $(".js_featured_research_publishedworkbyfellows .featured-carousel .card-wrapper p, .featured-carousel .card-wrapper p").dotdotdot({
        //     height: 70,
        //     fallbackToLetter: true,
        //     watch: true,
        // });
        $("body .featured-carousel .author-detail .editor").dotdotdot({
            height: 25,
            fallbackToLetter: true,
            watch: true,
        });
    });
})(jQuery);